var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEarnNavChartShow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H9C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20H4V3Z",
    fill: "#1F292E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7071 6.29289C19.3166 5.90237 18.6834 5.90237 18.2929 6.29289L14 10.5858L10.7071 7.29289C10.3166 6.90237 9.68342 6.90237 9.29289 7.29289L6.29289 10.2929C5.90237 10.6834 5.90237 11.3166 6.29289 11.7071C6.68342 12.0976 7.31658 12.0976 7.70711 11.7071L10 9.41421L13.2929 12.7071C13.6834 13.0976 14.3166 13.0976 14.7071 12.7071L19.7071 7.70711C20.0976 7.31658 20.0976 6.68342 19.7071 6.29289Z",
    fill: "#1F292E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5C18.5 18.8978 18.342 19.2794 18.0607 19.5607C17.7794 19.842 17.3978 20 17 20C16.6022 20 16.2206 19.842 15.9393 19.5607C15.658 19.2794 15.5 18.8978 15.5 18.5C15.5 18.1022 15.658 17.7206 15.9393 17.4393C16.2206 17.158 16.6022 17 17 17C17.3978 17 17.7794 17.158 18.0607 17.4393C18.342 17.7206 18.5 18.1022 18.5 18.5Z",
    fill: "#1F292E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14C14.2158 14 12.0031 15.743 11.0685 18.1362C10.9772 18.3701 10.9772 18.6299 11.0685 18.8638C12.0031 21.257 14.2158 23 17 23C19.7842 23 21.9969 21.257 22.9315 18.8638C23.0228 18.6299 23.0228 18.3701 22.9315 18.1362C21.9969 15.743 19.7842 14 17 14ZM17 21C15.2572 21 13.8209 20.003 13.0905 18.5C13.8209 16.997 15.2572 16 17 16C18.7428 16 20.1791 16.997 20.9095 18.5C20.1791 20.003 18.7428 21 17 21Z",
    fill: "#1F292E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEarnNavChartShow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_earn_nav_chart_show.e4671d4227693fdff138c16c56eb0c57.svg";